(function () {
    function init(root) {
        const cards = root.querySelectorAll('[data-two-video-card]');
        cards.forEach((card) => {
            const btn = card.querySelector('[data-two-video-play]');
            const player = card.querySelector('.two-videos__player');
            if (!btn || !player) return;

            btn.addEventListener('click', () => {
                const type = player.getAttribute('data-type');

                // Hide overlay immediately
                card.classList.add('is-playing');

                if (type === 'youtube') {
                    const id = player.getAttribute('data-yt-id');
                    const iframe = player.querySelector('[data-two-video-iframe]');
                    if (!id || !iframe) return;

                    // Autoplay is usually allowed only if muted
                    const base = `https://www.youtube.com/embed/${id}`;
                    const params = 'rel=0&modestbranding=1&playsinline=1&autoplay=1&mute=1';
                    iframe.src = `${base}?${params}`;

                } else if (type === 'uploaded') {
                    const video = player.querySelector('video');
                    if (!video) return;

                    // Show controls once started for a consistent UX
                    video.setAttribute('controls', 'controls');

                    // Some browsers block play if not initiated by a user gesture (this is a click, so OK)
                    const playPromise = video.play();
                    if (playPromise && typeof playPromise.catch === 'function') {
                        playPromise.catch(() => {
                            // If play fails, show overlay back
                            card.classList.remove('is-playing');
                        });
                    }

                    // If user pauses, optionally show the overlay again (nice touch)
                    video.addEventListener('pause', () => {
                        // only show if it's not ended
                        if (!video.ended) card.classList.remove('is-playing');
                    });

                    video.addEventListener('play', () => {
                        card.classList.add('is-playing');
                    });
                }
            });
        });
    }

    document.addEventListener('DOMContentLoaded', () => {
        init(document);
    });

    // Shopify theme editor support (when sections reload)
    document.addEventListener('shopify:section:load', (e) => {
        init(e.target);
    });
})();
